{
    "RTE_Label": "Commencez à taper...",
    "NAME": "RichTextEditor"
}